function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyPendingsService from '@/apps/data-platform/services/tables_views/my_pendings_service';
import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import { textsDefaul, ACCESS_TYPE_FLOW, TYPE_CHANGE_METADA, GA_EVENTS } from '@/js/constants';
import utils from '@/js/utils';
import FormMetaDatasource from '@/components/tableau/FormMetaDatasource';
import FormMetaDashboard from '@/components/tableau/FormMetaDashboard';
import FormMetaDataset from '@/modules/tasks/powerbi/components/FormMetaDataset';
import FormMetaReport from '@/modules/tasks/powerbi/components/report/FormMetaReport';
import FormMetaReportDatastudio from '@/modules/tasks/datastudio/components/FormMetaReportDatastudio';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import DatastudioDatasourceService from '@/apps/data-platform/services/visualization/datastudio_datasource_service';
import DialogsComponent from '@/components/DialogsComponent.vue';
import FormMetadataTableComponent from '../../components/FormMetadataTableComponent.vue';
import PaginationVue from '@/components/PaginationVue.vue';
import StateComponent from '@/components/StateComponent.vue';
import FormMetaDatasourceDatastudio from '@/modules/tasks/datastudio/components/FormMetaDatasourceDatastudio';
import { mapState } from 'vuex';
import { tabsMixin } from '@/mixins/tabs_mixim';
import tasks from '@/js/tasks';
export default {
  name: 'OwnershipPage',
  mixins: [tabsMixin],
  components: {
    FormMetaDatasource: FormMetaDatasource,
    FormMetaDashboard: FormMetaDashboard,
    FormMetaDataset: FormMetaDataset,
    FormMetaReport: FormMetaReport,
    FormMetaReportDatastudio: FormMetaReportDatastudio,
    DialogsComponent: DialogsComponent,
    FormMetadataTableComponent: FormMetadataTableComponent,
    PaginationVue: PaginationVue,
    StateComponent: StateComponent,
    FormMetaDatasourceDatastudio: FormMetaDatasourceDatastudio
  },
  data: function data() {
    return {
      aux: 'asd',
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      MODAL_NAME_METADATA: 'ContPendingAssignmentsMeModal',
      queryResponse: {
        list_approval: []
      },
      tplToUpdate: {},
      messageEmptyList: textsDefaul.LOADING,
      messageEmptyListDataSource: textsDefaul.LOADING,
      messageEmptyListWorkBook: textsDefaul.LOADING,
      messageEmptyListDataset: textsDefaul.LOADING,
      messageEmptyListReport: textsDefaul.LOADING,
      filter: {
        text_filter: ''
      },
      text_filter: '',
      filterOn: [],
      lst_datasource: [],
      lst_dataset: [],
      lst_report: [],
      lst_report_ds: [],
      lst_datasource_ds: [],
      data_ds: null,
      data_wb: null,
      data_dset: null,
      data_report: {},
      data_datasource_ds: null,
      title_modal_datasource: '',
      title_modal_workbook: '',
      title_modal_dataset: '',
      title_modal_report: '',
      object_name: '',
      path_name: '',
      response_text: '',
      valid_response_text: true,
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      objeto: null,
      lst_workbook: null,
      typeSelected: 1,
      filter_enabled: false,
      //
      pagination: {
        current: 1,
        limit: 10,
        total: 0
      },
      collapse_filter: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['ds_response_text'])), mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    tab: function tab() {
      return {
        tables: this.traductor('tabs.tables'),
        tbl_datasources: this.traductor('tabs.tbl_datasources'),
        tbl_dashboards: this.traductor('tabs.tbl_dashboards'),
        pbi_datasets: this.traductor('tabs.pbi_datasets'),
        pbi_reports: this.traductor('tabs.pbi_reports'),
        gds_reports: this.traductor('tabs.gds_reports')
      };
    },
    object_types: function object_types() {
      return [{
        value: 1,
        text: this.traductor('my_pendings.tables')
      }, {
        value: 2,
        text: this.traductor('my_pendings.datasources')
      }, {
        value: 3,
        text: this.traductor('my_pendings.dashboards')
      }, {
        value: 4,
        text: this.traductor('my_pendings.datasets')
      }, {
        value: 5,
        text: this.traductor('my_pendings.reports')
      }, {
        value: 6,
        text: this.traductor('my_pendings.reports_lds')
      }, {
        value: 7,
        text: this.traductor('my_pendings.datasources_lds')
      }];
    },
    tableFields: function tableFields() {
      return [{
        text: this.traductor('my_pendings.tablas.table'),
        value: 'tableReference.tableId',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        value: 'request',
        text: this.traductor('my_pendings.tablas.request'),
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'left'
      }];
    },
    tableauFields: function tableauFields() {
      return [{
        text: this.traductor('my_pendings.tablas.datasource'),
        value: 'objectReference.object_name',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        value: 'request',
        text: this.traductor('my_pendings.tablas.request'),
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'left'
      }];
    },
    tableauFieldsWorkBook: function tableauFieldsWorkBook() {
      return [{
        text: this.traductor('my_pendings.tablas.dashboard'),
        value: 'objectReference.object_name',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        value: 'request',
        text: this.traductor('my_pendings.tablas.request'),
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'left'
      }];
    },
    powerbiFieldsDataset: function powerbiFieldsDataset() {
      return [{
        text: this.traductor('my_pendings.tablas.dataset'),
        value: 'objectReference.object_name',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        value: 'request',
        text: this.traductor('my_pendings.tablas.request'),
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'left'
      }];
    },
    powerbiFieldsReport: function powerbiFieldsReport() {
      return [{
        text: this.traductor('my_pendings.tablas.report'),
        value: 'objectReference.object_name',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        value: 'request',
        text: this.traductor('my_pendings.tablas.request'),
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'left'
      }];
    },
    datastudioFieldsReport: function datastudioFieldsReport() {
      return [{
        text: this.traductor('my_pendings.tablas.report'),
        value: 'objectReference.object_name',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        value: 'request',
        text: this.traductor('my_pendings.tablas.request'),
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'left'
      }];
    },
    datastudioFieldsDatasource: function datastudioFieldsDatasource() {
      return [{
        text: this.traductor('my_pendings.tablas.datasource'),
        value: 'objectReference.object_name',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        value: 'request',
        text: this.traductor('my_pendings.tablas.request'),
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'left'
      }];
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.getTitlePendings(this.typeSelected - 1),
        disabled: true
      }];
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  }),
  created: function created() {
    switch (this.typeSelected) {
      case 1:
        this.reloadList();
        break;
      case 2:
        this.reloadDatasouce();
        break;
      case 3:
        this.reloadWorkBook();
        break;
      case 4:
        this.reloadDataset();
        break;
      case 5:
        this.reloadReport();
        break;
      case 6:
        this.reloadReportDatastudio();
        break;
      case 7:
        this.reloadDatasourceDatastudio();
        break;
    }
  },
  methods: {
    test: function test() {
      console.log('asd');
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    sendToFilter: function sendToFilter(q) {
      this.filter = q;
    },
    acceptOwner: function acceptOwner(row) {
      var _this = this;
      console.log('aqui');
      var responseToSend = utils.cloneJSON(row);
      var params = {
        tags: responseToSend.fields,
        id_firestore: responseToSend.id_firestore,
        response: responseToSend.response,
        index_node: responseToSend.index_node,
        domain_table: responseToSend.domain_table
      };
      MyPendingsService.changeMetadata(params).then(function (response) {
        if (response.code === 200) {
          _this.reloadList();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    openAcceptOwner: function openAcceptOwner(item) {
      var tplToUpdate = utils.cloneJSON(item);
      this.tplToUpdate = {
        objects: {
          tags: tplToUpdate.fields
        },
        item: tplToUpdate,
        tipo: 'edicion'
      };
      // this.$bvModal.show(this.MODAL_NAME_METADATA)
      this.$refs[this.MODAL_NAME_METADATA].onOpen();
    },
    saveTags: function saveTags(returnPreview) {
      var _this2 = this;
      var returnPreviewClone = utils.cloneJSON(returnPreview);
      var responseToSend = returnPreviewClone.item;
      console.log('obj:', responseToSend);
      var params = {
        tags: responseToSend.fields,
        id_firestore: responseToSend.id_firestore,
        ownerResponse: returnPreviewClone.response,
        index_node: responseToSend.index_node,
        domain_table: responseToSend.domain_table,
        source: returnPreviewClone.item.source ? returnPreviewClone.item.source : 'bigquery'
      };
      MyPendingsService.changeMetadata(params).then(function (response) {
        if (response.code === 200) {
          if (_this2.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.OWNERSHIP,
              object: 'table',
              domain_object: responseToSend.domain_table,
              operator: _this2.stringToHash(responseToSend.operator),
              company_code: _this2.companyCode,
              id_object: responseToSend.tableReference.projectId + '.' + responseToSend.tableReference.datasetId + '.' + responseToSend.tableReference.tableId,
              hash_email: _this2.stringToHash(userInfo.email),
              module: 'data_platform',
              status: 'accepted'
            });
          }
          tasks.toast.success('Done. Now this table will be available in "My tables"');
          // alert('Now this table will be available in "My tables"')
          // this.$bvModal.hide(this.MODAL_NAME_METADATA)
          _this2.$refs[_this2.MODAL_NAME_METADATA].onClose();
          _this2.reloadList();
        }
      }).catch(function (e) {
        utils.printError(e);
        // this.saveTags(returnPreview)
      });
      return true;
    },
    refuseOwner: function refuseOwner(row) {
      var _this3 = this;
      var refuseToSend = utils.cloneJSON(row.item);
      var params = {
        response: refuseToSend.response,
        id_firestore: refuseToSend.id_firestore,
        domain_table: refuseToSend.domain_table
      };
      MyPendingsService.reject(params).then(function () {
        if (_this3.$gtm.enabled() && window.dataLayer) {
          window.dataLayer.push({
            event: GA_EVENTS.OWNERSHIP,
            object: 'table',
            domain_object: refuseToSend.domain_table,
            operator: _this3.stringToHash(refuseToSend.operator),
            company_code: _this3.companyCode,
            id_object: refuseToSend.tableReference.projectId + '.' + refuseToSend.tableReference.datasetId + '.' + refuseToSend.tableReference.tableId,
            hash_email: _this3.stringToHash(userInfo.email),
            module: 'data_platform',
            status: 'rejected'
          });
        }
        _this3.$refs[_this3.MODAL_NAME_METADATA].onClose();
        _this3.reloadList();
      }).catch(function (e) {
        utils.printError(e);
        // this.refuseOwner(row)
      });
    },
    reloadList: function reloadList() {
      var _this4 = this;
      // reload section table
      this.resetPagination();
      var typeFlow = ACCESS_TYPE_FLOW.APPROVE_OWNER;
      var email = window.userInfo.email;
      this.queryResponse = {
        list_approval: []
      };
      MyPendingsService.listPendingApproval(typeFlow, email).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.list_approval && response.data.list_approval.length) {
            console.log('primer if');
            console.log(_this4.queryResponse);
            _this4.pagination.total = response.data.list_approval.length;
            _this4.queryResponse = response.data || {};
            _this4.aux = _this4.queryResponse.list_approval;
          } else {
            _this4.queryResponse = {
              list_approval: []
            };
            _this4.messageEmptyList = _this4.$i18n.t('frases.no_found');
            _this4.aux = [];
          }
        } else {
          // this.reloadList()
        }
        console.log(_this4.pagination);
      }).catch(function (e) {
        utils.printError(e);
        // this.reloadList()
      });
    },
    reloadDatasouce: function reloadDatasouce() {
      var _this5 = this;
      this.resetPagination();
      var typeFlow = ACCESS_TYPE_FLOW.APPROVE_OWNER;
      var email = window.userInfo.email;
      var userInfo = window.userInfo;
      this.lst_datasource = [];
      TableauDatasourceService.tableauDataSourcePendingApproval(typeFlow, email, userInfo.domain).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.items && response.data.items.length) {
            _this5.pagination.total = response.data.items.length;
            _this5.lst_datasource = response.data.items;
          } else {
            _this5.lst_datasource = [];
            _this5.messageEmptyListDataSource = _this5.$i18n.t('frases.no_found');
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    reloadWorkBook: function reloadWorkBook() {
      var _this6 = this;
      this.resetPagination();
      var typeFlow = ACCESS_TYPE_FLOW.APPROVE_OWNER;
      var email = window.userInfo.email;
      var domain = window.userInfo.domain;
      this.lst_workbook = [];
      TableauDashboardService.tableauWorkBookPendingApproval({
        typeFlow: typeFlow,
        email: email,
        domain: domain
      }).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.items && response.data.items.length) {
            _this6.pagination.total = response.data.items.length;
            _this6.lst_workbook = response.data.items;
          } else {
            _this6.lst_workbook = [];
            _this6.messageEmptyListWorkBook = _this6.$i18n.t('frases.no_found');
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    reloadDataset: function reloadDataset() {
      var _this7 = this;
      this.resetPagination();
      var typeFlow = ACCESS_TYPE_FLOW.APPROVE_OWNER;
      var email = window.userInfo.email;
      var domain = window.userInfo.domain;
      this.lst_dataset = [];
      BiDatasetService.datasetPendingApproval({
        typeFlow: typeFlow,
        email: email,
        domain: domain
      }).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.items && response.data.items.length) {
            _this7.pagination.total = response.data.items.length;
            _this7.lst_dataset = response.data.items;
          } else {
            _this7.lst_dataset = [];
            _this7.messageEmptyListDataset = _this7.$i18n.t('frases.no_found');
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    reloadReport: function reloadReport() {
      var _this8 = this;
      this.resetPagination();
      var typeFlow = ACCESS_TYPE_FLOW.APPROVE_OWNER;
      var email = window.userInfo.email;
      var domain = window.userInfo.domain;
      this.lst_report = [];
      BiReportService.reportPendingApproval({
        typeFlow: typeFlow,
        email: email,
        domain: domain
      }).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.items && response.data.items.length) {
            _this8.pagination.total = response.data.items.length;
            _this8.lst_report = response.data.items;
          } else {
            _this8.lst_report = [];
            _this8.messageEmptyListReport = _this8.$i18n.t('frases.no_found');
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    reloadReportDatastudio: function reloadReportDatastudio() {
      var _this9 = this;
      this.resetPagination();
      var typeFlow = ACCESS_TYPE_FLOW.APPROVE_OWNER;
      var email = window.userInfo.email;
      var domain = window.userInfo.domain;
      this.lst_report = [];
      DatastudioReportService.reportPendingApproval({
        typeFlow: typeFlow,
        email: email,
        domain: domain
      }).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.items && response.data.items.length) {
            _this9.pagination.total = response.data.items.length;
            _this9.lst_report_ds = response.data.items;
          } else {
            _this9.lst_report_ds = [];
            _this9.messageEmptyListReport = _this9.$i18n.t('frases.no_found');
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    reloadDatasourceDatastudio: function reloadDatasourceDatastudio() {
      var _this0 = this;
      this.resetPagination();
      var typeFlow = ACCESS_TYPE_FLOW.APPROVE_OWNER;
      var email = window.userInfo.email;
      var domain = window.userInfo.domain;
      this.lst_datasource_ds = [];
      DatastudioDatasourceService.datasetPendingApproval({
        typeFlow: typeFlow,
        email: email,
        domain: domain
      }).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.items && response.data.items.length) {
            _this0.pagination.total = response.data.items.length;
            console.log('response', response.data.items);
            _this0.lst_datasource_ds = response.data.items.map(function (it) {
              return _objectSpread(_objectSpread({}, it), {}, {
                objectReference: _objectSpread(_objectSpread({}, it.objectReference), {}, {
                  business_terms: it.objectReference.business_terms || it.objectReference.bussines_terms || []
                })
              });
            });
            console.log('lst_datasource_ds', _this0.lst_datasource_ds);
          } else {
            _this0.lst_datasource_ds = [];
            _this0.messageEmptyListDataset = _this0.$i18n.t('frases.no_found');
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onTableauDataSourceOwner: function onTableauDataSourceOwner(item) {
      this.objeto = item;
      this.title_modal_datasource = "DATASOURCE: ".concat(item.objectReference.path_name, "/").concat(item.objectReference.object_name);
      this.data_ds = item.objectReference;
      var columns = [];
      item.fields.forEach(function (element, index) {
        columns.push(_objectSpread({}, element[index]['fields']));
      });
      this.data_ds['columns'] = columns;
      this.object_name = item.objectReference.object_name;
      this.path_name = item.objectReference.path_name;
      this.data_ds['environment'] = item.objectReference.environment;
      this.data_ds['document_id'] = item.table_id;
      this.data_ds['request_id'] = item.id;
      this.$store.commit('data-platform/set_ds_response_text', {
        texto: ''
      });
      // this.$bvModal.show('modalPendientTableauDataSource')
      this.$refs['modalPendientTableauDataSource'].onOpen();
    },
    onTableauWorkBookOwner: function onTableauWorkBookOwner(item) {
      this.title_modal_workbook = "WORKBOOK: ".concat(item.objectReference.path_name, "/").concat(item.objectReference.object_name);
      this.data_wb = item.objectReference;
      var columns = [];
      item.fields.forEach(function (element, index) {
        columns.push(_objectSpread({}, element[index]['fields']));
      });
      this.data_wb['document_id'] = item.table_id;
      this.data_wb['columns'] = columns;
      this.data_wb['environment'] = item.objectReference.environment;
      this.data_wb['request_id'] = item.id;
      this.$store.commit('data-platform/set_ds_response_text', {
        texto: ''
      });
      // this.$bvModal.show('modalPendientTableauWorkBook')
      this.$refs['modalPendientTableauWorkBook'].onOpen();
    },
    onPowerbiDatasetOwner: function onPowerbiDatasetOwner(item) {
      this.title_modal_workbook = "DATASET: ".concat(item.objectReference.path_name, "/").concat(item.objectReference.object_name);
      this.data_dset = item.objectReference;
      var columns = [];
      item.fields.forEach(function (element, index) {
        columns.push(_objectSpread({}, element[index]['fields']));
      });
      this.data_dset['dataset_id'] = item.dataset_id;
      this.data_dset['columns'] = columns;
      this.data_dset['environment'] = item.objectReference.environment;
      this.data_dset['request_id'] = item.id;
      this.$store.commit('data-platform/set_ds_response_text', {
        texto: ''
      });
      // this.$bvModal.show('modalPendientPowerbiDataset')
      this.$refs['modalPendientPowerbiDataset'].onOpen();
    },
    onPowerbiReportOwner: function onPowerbiReportOwner(item) {
      this.title_modal_report = "REPORT: ".concat(item.objectReference.path_name, " / ").concat(item.objectReference.object_name);
      this.data_report = item.objectReference;
      this.data_report['document_id'] = item.document_id;
      var columns = [];
      item.fields.forEach(function (element, index) {
        columns.push(_objectSpread({}, element[index]['fields']));
      });
      this.data_report['report_id'] = item.report_id;
      this.data_report['columns'] = columns;
      this.data_report['environment'] = item.objectReference.environment;
      this.data_report['request_id'] = item.id;
      this.$store.commit('data-platform/set_ds_response_text', {
        texto: ''
      });
      // this.$bvModal.show('modalPendientPowerbiReport')
      this.$refs['modalPendientPowerbiReport'].onOpen();
    },
    onDatastudioReportOwner: function onDatastudioReportOwner(item) {
      this.title_modal_report = "REPORT: ".concat(item.objectReference.object_name);
      this.data_report = item.objectReference;
      this.data_report['document_id'] = item.document_id;
      var columns = [];
      item.fields.forEach(function (element, index) {
        columns.push(_objectSpread({}, element[index]['fields']));
      });
      this.data_report['report_id'] = item.report_id;
      this.data_report['columns'] = columns;
      this.data_report['environment'] = item.objectReference.environment;
      this.data_report['request_id'] = item.id;
      this.$store.commit('data-platform/set_ds_response_text', {
        texto: ''
      });
      // this.$bvModal.show('modalPendientDatastudioReport')
      this.$refs['modalPendientDatastudioReport'].onOpen();
    },
    onDatastudioDatasourceOwner: function onDatastudioDatasourceOwner(item) {
      console.log(item, 'item - onDatastudioDatasourceOwner');
      this.title_modal_workbook = "DATASOURCE: ".concat(item.objectReference.path_name, "/").concat(item.objectReference.object_name);
      this.data_datasource_ds = JSON.parse(JSON.stringify(item.objectReference));
      console.log('BT len:', this.data_datasource_ds.business_terms);
      console.log('BT len:', this.data_datasource_ds.business_terms.length);
      var columns = [];
      item.fields.forEach(function (element, index) {
        columns.push(_objectSpread({}, element[index]['fields']));
      });
      var business_terms = item.business_terms.map(function (bt) {
        return bt;
      });
      console.log(business_terms, 'item.business_terms');
      console.log(this.data_datasource_ds, 'this.data_datasource_ds');
      this.data_datasource_ds['dataset_id'] = item.document_id;
      this.data_datasource_ds['datasource_id'] = item.datasource_id;
      this.data_datasource_ds['columns'] = columns;
      this.data_datasource_ds['environment'] = item.objectReference.environment;
      this.data_datasource_ds['request_id'] = item.id;
      this.$set(this.data_datasource_ds, 'terminos_negocio', item.business_terms.map(function (bt) {
        return bt;
      }) || []);
      this.$set(this.data_datasource_ds, 'business_terms', item.business_terms.map(function (bt) {
        return bt;
      }) || []);
      console.log(this.data_datasource_ds, 'this.data_datasource_ds');
      this.$store.commit('data-platform/set_ds_response_text', {
        texto: ''
      });
      // this.$bvModal.show('modalPendientDatastudioDatasource')
      this.$refs['modalPendientDatastudioDatasource'].onOpen();
    },
    onCloseModalDataSource: function onCloseModalDataSource() {
      // this.$bvModal.hide('modalPendientTableauDataSource')
      this.$refs['modalPendientTableauDataSource'].onClose();
      this.reloadDatasouce();
    },
    onCloModalWorkBook: function onCloModalWorkBook() {
      // this.$bvModal.hide('modalPendientTableauWorkBook')
      this.$refs['modalPendientTableauWorkBook'].onClose();
      this.reloadWorkBook();
    },
    onCloModalDataset: function onCloModalDataset() {
      // this.$bvModal.hide('modalPendientPowerbiDataset')
      this.$refs['modalPendientPowerbiDataset'].onClose();
      this.reloadDataset();
    },
    onCloModalReport: function onCloModalReport() {
      // this.$bvModal.hide('modalPendientPowerbiReport')
      this.$refs['modalPendientPowerbiReport'].onClose();
      this.reloadReport();
    },
    onCloModalReportDatastudio: function onCloModalReportDatastudio() {
      // this.$bvModal.hide('modalPendientDatastudioReport')
      this.$refs['modalPendientDatastudioReport'].onClose();
      this.reloadReportDatastudio();
    },
    onCloModalDatasourceDatastudio: function onCloModalDatasourceDatastudio() {
      this.$refs['modalPendientDatastudioDatasource'].onClose();
      this.reloadDatasourceDatastudio();
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onSearch: function onSearch() {
      console.log(this.text_filter);
      this.filter.text_filter = this.text_filter;
    },
    onLimpiar: function onLimpiar() {
      this.filter.text_filter = '';
      this.text_filter = '';
    },
    onChangeType: function onChangeType() {
      this.filter.text_filter = '';
      this.text_filter = '';
      switch (this.typeSelected) {
        case 1:
          this.reloadList();
          this.aux = this.queryResponse.list_approval;
          console.log(this.aux);
          break;
        case 2:
          this.reloadDatasouce();
          this.aux = this.lst_datasource;
          console.log(this.aux);
          break;
        case 3:
          this.reloadWorkBook();
          this.aux = this.lst_workbook;
          console.log(this.aux);
          break;
        case 4:
          this.reloadDataset();
          this.aux = this.lst_dataset;
          console.log(this.aux);
          break;
        case 5:
          this.reloadReport();
          this.aux = this.lst_report;
          console.log(this.aux);
          break;
        case 6:
          this.reloadReportDatastudio();
          this.aux = this.lst_report_ds;
          console.log(this.aux);
          break;
        case 7:
          this.reloadDatasourceDatastudio();
          this.aux = this.lst_datasource_ds;
          console.log(this.aux);
          break;
      }
    },
    resetPagination: function resetPagination() {
      this.pagination = {
        limit: 10,
        current: 1,
        total: 0
      };
    }
  }
};